import {
  TStudentFeeSummary,
  TStudentFeeViewType,
} from '../../apis/admissions/adminssionFees.interfaces';
import { mockUserDetailsList } from '../users/userDetailListMock';

export const studentFeesMock: TStudentFeeSummary[] = [
  {
    feeId: 'fee-1-oct2024',
    userId: mockUserDetailsList[0].id,
    feeAmount: 500,
    feePaid: 500,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-10',
  },
  {
    feeId: 'fee-2-oct2024',
    userId: mockUserDetailsList[1].id,
    feeAmount: 750,
    feePaid: 0,
    feeDue: 750,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-3-oct2024',
    userId: mockUserDetailsList[2].id,
    feeAmount: 600,
    feePaid: 0,
    feeDue: 600,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-4-oct2024',
    userId: mockUserDetailsList[3].id,
    feeAmount: 550,
    feePaid: 550,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-12',
  },
  {
    feeId: 'fee-5-oct2024',
    userId: mockUserDetailsList[4].id,
    feeAmount: 800,
    feePaid: 0,
    feeDue: 800,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-6-oct2024',
    userId: mockUserDetailsList[5].id,
    feeAmount: 700,
    feePaid: 0,
    feeDue: 700,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-7-oct2024',
    userId: mockUserDetailsList[6].id,
    feeAmount: 650,
    feePaid: 650,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-08',
  },
  {
    feeId: 'fee-8-oct2024',
    userId: mockUserDetailsList[7].id,
    feeAmount: 720,
    feePaid: 0,
    feeDue: 720,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-9-oct2024',
    userId: mockUserDetailsList[8].id,
    feeAmount: 680,
    feePaid: 0,
    feeDue: 680,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-10-oct2024',
    userId: mockUserDetailsList[9].id,
    feeAmount: 590,
    feePaid: 590,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-14',
  },
  {
    feeId: 'fee-11-oct2024',
    userId: mockUserDetailsList[10].id,
    feeAmount: 770,
    feePaid: 0,
    feeDue: 770,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-12-oct2024',
    userId: mockUserDetailsList[11].id,
    feeAmount: 630,
    feePaid: 0,
    feeDue: 630,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-13-oct2024',
    userId: mockUserDetailsList[12].id,
    feeAmount: 710,
    feePaid: 710,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-11',
  },
  {
    feeId: 'fee-14-oct2024',
    userId: mockUserDetailsList[13].id,
    feeAmount: 690,
    feePaid: 0,
    feeDue: 690,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-15-oct2024',
    userId: mockUserDetailsList[14].id,
    feeAmount: 740,
    feePaid: 0,
    feeDue: 740,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-16-oct2024',
    userId: mockUserDetailsList[15].id,
    feeAmount: 620,
    feePaid: 620,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-13',
  },
  {
    feeId: 'fee-17-oct2024',
    userId: mockUserDetailsList[16].id,
    feeAmount: 780,
    feePaid: 0,
    feeDue: 780,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-18-oct2024',
    userId: mockUserDetailsList[17].id,
    feeAmount: 660,
    feePaid: 0,
    feeDue: 660,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-19-oct2024',
    userId: mockUserDetailsList[18].id,
    feeAmount: 730,
    feePaid: 730,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-09',
  },
  {
    feeId: 'fee-20-oct2024',
    userId: mockUserDetailsList[19].id,
    feeAmount: 670,
    feePaid: 0,
    feeDue: 670,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-21-oct2024',
    userId: mockUserDetailsList[20].id,
    feeAmount: 760,
    feePaid: 0,
    feeDue: 760,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-22-oct2024',
    userId: mockUserDetailsList[21].id,
    feeAmount: 640,
    feePaid: 640,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-07',
  },
  {
    feeId: 'fee-23-oct2024',
    userId: mockUserDetailsList[22].id,
    feeAmount: 790,
    feePaid: 0,
    feeDue: 790,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-24-oct2024',
    userId: mockUserDetailsList[23].id,
    feeAmount: 610,
    feePaid: 0,
    feeDue: 610,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
  {
    feeId: 'fee-25-oct2024',
    userId: mockUserDetailsList[24].id,
    feeAmount: 700,
    feePaid: 700,
    feeDue: 0,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.PAID,
    feePaidDate: '2024-10-06',
  },
  {
    feeId: 'fee-26-oct2024',
    userId: mockUserDetailsList[25].id,
    feeAmount: 720,
    feePaid: 0,
    feeDue: 720,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.UNPAID,
    feePaidDate: '',
  },
  {
    feeId: 'fee-27-oct2024',
    userId: mockUserDetailsList[26].id,
    feeAmount: 680,
    feePaid: 0,
    feeDue: 680,
    feeDueDate: '2024-10-15',
    status: TStudentFeeViewType.OVERDUE,
    feePaidDate: '',
  },
];

// Helper function to get fees by user ID
export const getFeesByUserId = (userId: string): TStudentFeeSummary[] =>
  studentFeesMock.filter((fee) => fee.userId === userId);

// Helper function to get all unpaid fees
export const getUnpaidFees = (): TStudentFeeSummary[] =>
  studentFeesMock.filter((fee) => fee.status === TStudentFeeViewType.UNPAID);

// Helper function to update fee status
export const updateFeeStatus = (
  feeId: string,
  newStatus:
    | TStudentFeeViewType.PAID
    | TStudentFeeViewType.UNPAID
    | TStudentFeeViewType.OVERDUE
): void => {
  const feeIndex = studentFeesMock.findIndex((fee) => fee.feeId === feeId);
  if (feeIndex !== -1) {
    studentFeesMock[feeIndex] = {
      ...studentFeesMock[feeIndex],
      status: newStatus,
    };
  }
};
